import { RootState } from '@store/reducers';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './aadhar.css';
import Button from '@components/common/Button';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import endpoints from '@config/endpoints';
import { sanitizeName } from '@utils/childUtils';
import {
  getData,
  postDataJSON,
} from '../../../../services/CommonApiService';
import { getUserConsentLanguage } from '@services/childApiServices';
import { Spinner } from 'react-bootstrap';
import {
  beneficiaryAlreadyInRCH,
  setAadhar,
  setBeneficiaryMobileNumber,
  setConsentLanguage,
  setTsnID,
} from '@store/actions/beneficiaryAction';
import CheckboxComponent from '@components/common/CheckBox';
import {
  encodeWithKeyAndShift,
  decodeWithKeyAndShift,
} from '../../../../utils/base64Utils';
import { isValueContainsOnlyDigits } from '@utils/hrpConditionCheck';
import { errorLogger } from '@utils/applicationLogUtils';
import { toast } from 'react-toastify';
import { benef_error_const } from '@constants/beneficiaryConstant';
import { useOtpCooldown, isOtpRateLimited, isOtpRateLimitedError } from '@hooks/useOtpCooldown';
import { otpCooldownMessage } from '@constants/appConstants';
 
interface showModalProps {
  handleClose: (authType: string) => void;
  setLinkedBenefDetails:Dispatch<SetStateAction<string>>;
}
 
const AadharModal = ({ handleClose, setLinkedBenefDetails }: showModalProps) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [aadhaarName, setAadhaarName] = useState<string>('');
  const [aadharNameErrorMessage, setAadharNameErrorMessage] = useState<string>('');
  const [isAadharNameError, setIsAadharNameError] = useState<boolean>(false);

  const [showSpinner, setSHowSpinner] = useState<boolean>(false);
  const [isAadharError, setIsAadharError] = useState<boolean>(false);
  const [aadharErrorMessage, setAadharErrorMessage] = useState<string>('');
  const [mobileErrorMessage, setMobileErrorMessage] = useState<string>('');
  const [consentShow, setConsentShow] = useState<boolean>(false);
  const [isMobileError, setIsMobileError] = useState<boolean>(false);
  const [mobileValue, setMobileValue] = useState<string>('');
  const [consentCheckbox, setConsentCheckbox] = useState<boolean>(false);
  const beneficiary = useSelector((state: RootState) => state.beneficiary);
  const [consentLanguageData, setConsentLanguageData] = useState<any>([]);
  const [checkedState, setCheckedState] = useState<boolean[]>([]);
  const userDetails = localStorage.getItem('userDetails');
  const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));
  const dispatch = useDispatch();
  const { secondsLeft, isCoolingDown, startCooldown } = useOtpCooldown(inputValue);
 
  const isAllChecked = checkedState?.every((checked) => checked);

  const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
          <div>
              <p><strong>ABDM:</strong> {abdmMessage}</p>
              {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
          </div>
      );
  
      const handleError = (message: string, rchMessage?: string) => {
          const errorMessage = createErrorMessage(message, rchMessage);
          toast.error(errorMessage, {
              position: "top-center",
          });
          setSHowSpinner(false);
      };
 
 
  useEffect(() => {
    getConsentLanguage();
  }, []);
 
  const getConsentLanguage = async () => {
    try {
      const type = "Beneficiary"
      const consent = "aadhaar"      
      const response = await getUserConsentLanguage(type, consent);
      setConsentLanguageData(response);
      const res:any = response?.data[0]?.length // 6
      setCheckedState(new Array(res).fill(false))
    }     catch(error:any){
           errorLogger(error?.response?.data||error?.response||error)
        }
  };
 
  const handleCheckboxChange = (index: number, checked: boolean) => {
    const updatedCheckedState = [...checkedState];
    updatedCheckedState[index] = checked;
    setCheckedState(updatedCheckedState);
  };
 
  const handleSelectAll = (checked: boolean) => {
    setCheckedState(new Array(checkedState?.length).fill(checked));
  };
 
  const handleAadharChange = (event: any) => {
    const isValue = isValueContainsOnlyDigits(event);
    if(isValue) {
      setInputValue(event);
    } else if(event.length === 0) {
      setInputValue('')
    }
  };
  const handleAadharNameChange = (event: any) => {
    const sanitizedValue = sanitizeName(event);
    setAadhaarName(sanitizedValue)
  };
  const handletoAadhar = () => {
    setConsentCheckbox(true);
    setConsentShow(false);
  };
  const handleMobileChange = (event: any) => {
    const isValue = isValueContainsOnlyDigits(event);
    setIsMobileError(false);
    if(isValue) {
      setMobileValue(event);
    } else if(event.length === 0) {
      setMobileValue('');
    }    
  };
  const isError: boolean[] = [];
  useEffect(() => {}, [consentShow]);
  const handleSaveAdhar = async () => {
    if (inputValue.length !== 12) {
      setAadharErrorMessage(
        'Aadhaar number Must Contain 12 Digits. Enter a valid Aadhaar number.',
      );
      setIsAadharError(true);
      isError[0] = true;
    } else {
      setIsAadharError(false);
      isError[0] = false;
      dispatch(setAadhar(inputValue));
    }
    if (beneficiary.beneficiaryAuthType === 'Demographics') {
      if (isError[0] === false && consentCheckbox) {
        dispatch(setAadhar(inputValue));
        handleClose('submit');
      }
    } else if (beneficiary.beneficiaryAuthType === 'Face_Auth_Creation') {
      // For Face Auth Creation, just save the data and proceed to Face Authentication Modal
      if (mobileValue.length !== 10) {
        setMobileErrorMessage(
          'Mobile number Must Contain 10 Digits. Enter a valid Mobile number.',
        );
        setIsMobileError(true);
        isError[1] = true;
      } else {
        setIsMobileError(false);
        isError[1] = false;
      }
      if (isError[1] === false && isError[0] === false && consentCheckbox) {
        // Save Aadhaar and Mobile without calling API
        dispatch(setAadhar(inputValue));
        dispatch(setBeneficiaryMobileNumber(mobileValue));
        const consentDetails = [
          ...consentLanguageData.data[0].map((item :any)=> ({
              consent_template_id: item.consent_template_id,
              conscent_template_content: item?.consent_template_content.includes('{#var1#}')
              ? item?.consent_template_content.replace(
                '{#var1#}',
                `${decodedUserData.first_name || ''} ${decodedUserData.last_name || ''}`
              )
            : item?.consent_template_content?.includes('{#name#}')
            ? item?.consent_template_content.replace(
                '{#name#}',
                `${aadhaarName.trim() || ''}`
              )
            : item?.consent_template_content
          })),
        ];
        dispatch(setConsentLanguage(consentDetails));
        // Proceed to Face Authentication Modal
        handleClose('submit');
      }
    } else {
      if (mobileValue.length !== 10) {
        setMobileErrorMessage(
          'Mobile number Must Contain 10 Digits. Enter a valid Mobile number.',
        );
        setIsMobileError(true);
        isError[1] = true;
      } else {
        setIsMobileError(false);
        isError[1] = false;
      }
      if (isError[1] === false && isError[0] === false && consentCheckbox) {
        if (isCoolingDown) {
          handleError(otpCooldownMessage);
          return;
        }
        const data = {
          aadhaar: inputValue,
        };
        try {
          setSHowSpinner(true);
          const encodedData = encodeWithKeyAndShift(
            JSON.stringify({
              mobileNumber: mobileValue,
            }),
          );
          const mobNumCheckResponse = await postDataJSON<any>(
            `${endpoints.checkBenefMobileNumberExists}`,
            { data: encodedData },
          );
          const decodedResponse = JSON.parse(
            decodeWithKeyAndShift(mobNumCheckResponse.data.data),
          );
          if (decodedResponse.isBenefExist === false) {
            try {
              dispatch(beneficiaryAlreadyInRCH(false))
              const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
              const aadharResponse = await postDataJSON<any>(
                `${endpoints.createAbhaViaAadhaar}`,
                { data: encodedPayload },
              );
              const decodedData = JSON.parse(
                decodeWithKeyAndShift(aadharResponse.data),
              );
              const res = decodedData;
              setSHowSpinner(false);
              const consentDetails = [
                ...consentLanguageData.data[0].map((item :any)=> ({
                    consent_template_id: item.consent_template_id,
                    conscent_template_content: item?.consent_template_content.includes('{#var1#}')
                    ? item?.consent_template_content.replace(
                      '{#var1#}',
                      `${decodedUserData.first_name || ''} ${decodedUserData.last_name || ''}`
                    )
                  : item?.consent_template_content?.includes('{#name#}')
                  ? beneficiary.beneficiaryAuthType === 'Demographics'? item?.consent_template_content.replace(
                    '{#name#},',
                    `${''}`
                  ) : item?.consent_template_content.replace(
                      '{#name#}',
                      `${aadhaarName.trim() || ''}`
                    )
                  : item?.consent_template_content
                })),
              ];
              dispatch(setConsentLanguage(consentDetails));
              dispatch(
                setBeneficiaryMobileNumber(`${res.message} ${mobileValue}`),
              );
              dispatch(setTsnID(res.txnId));
              dispatch(setAadhar(inputValue));
              if (res?.txnId) {
                dispatch(beneficiaryAlreadyInRCH(false))
                handleClose('submit');
              } 
              else if (res?.message?.includes('Runtime Error')) {
                handleError(`${res?.code} - ${res.message}`, benef_error_const.urlNotFound);
              } else if (res?.message?.includes('30 seconds')) {
                handleError(res?.message);
              } else if (res?.message?.includes('multiple OTPs')) {
                handleError(res?.message, benef_error_const.multipleOTP);
              } else if (res?.message?.includes('Missing Credentials')) {
                handleError(`${res?.code} - ${res?.description}`);
              } else if(res?.message?.includes('Too many request attempted')){
                handleError(`${res?.message}`);
              } else if (res?.message?.includes('Aadhaar Gateway is unavailable')) {
                handleError(res?.message);
              } else if (res?.loginId?.includes('Invalid LoginId')) {
                handleError(res?.loginId, benef_error_const.provideCorrectAadhaar);
              } else {
                handleError(res?.message ?? benef_error_const.genericAbdmMessage);
              }
            } catch (error) {
              if (isOtpRateLimitedError(error)) {
                startCooldown();
                handleError(otpCooldownMessage);
                return;
              }
              const decodedData = JSON.parse(decodeWithKeyAndShift(error));
              const res = decodedData;
              let catchErrorMessage = '';
              if(res?.message && res?.code){
                  catchErrorMessage =`${res?.code} - ${res?.message}`
              }else if(res?.message && !res?.code){
                  catchErrorMessage =`${res?.message}`
              }else if(res?.loginId){
                  catchErrorMessage =`${res?.loginId}`
              }else if(res?.Aadhaar){
                  catchErrorMessage =`${res?.Aadhaar}`
              }else{
                  catchErrorMessage = benef_error_const.genericAbdmMessage
              } 
              handleError(catchErrorMessage);
              errorLogger(res, "Aadhar OTP Generation-createAbhaViaAadhaar");
            }
          } else {
            dispatch(setBeneficiaryMobileNumber(`${mobileValue}`));
            dispatch(setAadhar(inputValue));
            dispatch(beneficiaryAlreadyInRCH(true))
            setSHowSpinner(false);
            setLinkedBenefDetails(decodedResponse.benefDetails)
            handleClose('show-exist-modal');
          }
        } catch (error) {
          setSHowSpinner(false);
          handleError(benef_error_const.unableToGenerateOtp);
        }
      }
    }
  };

  const checkConsentIsPresent = () => {
    if(consentLanguageData?.length === 0){
      toast.error("Unable to fetch consent details. Please try again later.", {
        position: "top-center",
      });
      getConsentLanguage();
      return;
    }
    setConsentShow(true);
  }
 
  return (
    <>
      <div>
        <div className="aadhar_container">
          {!consentShow && (
            <div className="aadhar_fields">
              <h1 className="aadhar_headings">
                {beneficiary.beneficiaryAuthType === 'Face_Auth_Creation' 
                  ? 'Verify with Face Authentication'
                  : `Register with Aadhaar(${beneficiary.beneficiaryAuthType})`
                }
              </h1>
              <InputFieldsComponent
                labelName="Enter Aadhaar Number"
                placeholder={'Type Here'}
                type={'text'}
                isDisabled={false}
                maximumLength={12}
                onChange={handleAadharChange}
                errorMessage={aadharErrorMessage}
                inputType={isAadharError ? 'error' : 'general'}
                value={inputValue}
                required={true}
              />
              {(beneficiary.beneficiaryAuthType === 'OTP' || beneficiary.beneficiaryAuthType === 'Face_Auth_Creation') && <InputFieldsComponent
                labelName="Enter Aadhaar Name"
                placeholder={'Type Here'}
                type={'text'}
                isDisabled={false}
                onChange={handleAadharNameChange}
                errorMessage={aadharNameErrorMessage}
                inputType={isAadharNameError ? 'error' : 'general'}
                value={aadhaarName}
                required={true}
              />}
              {(beneficiary.beneficiaryAuthType === 'OTP' || beneficiary.beneficiaryAuthType === 'Face_Auth_Creation') && (
                <InputFieldsComponent
                  labelName="Mobile Number Linked with Aadhaar"
                  placeholder={'Type Here'}
                  type={'text'}
                  isDisabled={false}
                  maximumLength={10}
                  errorMessage={mobileErrorMessage}
                  inputType={isMobileError ? 'error' : 'general'}
                  onChange={handleMobileChange}
                  value={mobileValue}
                  required={true}
                />
              )}
              <div className="aadhar_checkbox">
                <CheckboxComponent
                  className="align-item_check_box"
                  checkBoxName=""
                  disabled={false}
                  onCheckboxChange={() => {}}
                  placeCheckboxBefore={false}
                  isChecked={consentCheckbox}
                />
                <p>
                  I hearby confirm that I have explained below mentioned
                  <button
                    onClick={checkConsentIsPresent}
                    className="aadhar_consent_form"
                    disabled={(beneficiary.beneficiaryAuthType === 'OTP' || beneficiary.beneficiaryAuthType === 'Face_Auth_Creation') ? !inputValue.length || !aadhaarName.trim().length || !mobileValue.length: false}
                  >
                    Consent Process
                  </button>{' '}
                  to the individual for the creation of ABHA and linking with
                  JANANI programme/application
                </p>
              </div>
              {showSpinner && (
                <>
                  <span>Loading...</span>
                  <Spinner />
                </>
              )}
              {isCoolingDown && (
                <p style={{ color: '#b42318', fontSize: '12px', margin: '8px 0 0' }}>
                  You can request for new OTP after {secondsLeft} seconds
                </p>
              )}
              <div className="aadhar-submit">
                <Button
                  onClick={handleSaveAdhar}
                  disabled={
                    isCoolingDown ? true :
                    beneficiary.beneficiaryAuthType === 'Demographics'
                      ? (inputValue.length === 12 && consentCheckbox ? false : true)
                      : (beneficiary.beneficiaryAuthType === 'OTP' || beneficiary.beneficiaryAuthType === 'Face_Auth_Creation')
                        ? inputValue.length === 12 &&
                          mobileValue.length === 10 &&
                          consentCheckbox &&
                          aadhaarName.trim().length > 0
                          ? false
                          : true
                        : true
                  }
                  id="aadhar-beneficiary-submit"
                  buttonName={'Continue'}
                  colorType={'primary'}
                  icon={''}
                  iconPosition={''}
                />
              </div>
            </div>
          )}
          {consentShow && (
            <div className="aadhar_consent_form_enlarge">
              <h1 className="aadhar_headings">Consent Process</h1>
              <div className="consent_form_for_aadhar">
                I hereby declare that:
                {/* Select All Checkbox */}
                <CheckboxComponent
                  isChecked={isAllChecked}
                  onCheckboxChange={handleSelectAll}
                  disabled={false}
                  className="consent-select-all"
                  checkBoxName="Select All"
                />
                {/* Individual Checkboxes */}
                {consentLanguageData?.data[0]?.map((item: any, index: any) => (
                  <CheckboxComponent
                    key={index}
                    isChecked={checkedState?.[index]}
                    onCheckboxChange={(checked) =>
                      handleCheckboxChange(index, checked)
                    }
                    disabled={false}
                    className={`consent-checkbox-item-${index}`}
                    checkBoxName={
                      item?.consent_template_content.includes('{#var1#}')
                        ? item?.consent_template_content.replace(
                          '{#var1#}',
                          `${decodedUserData.first_name || ''} ${decodedUserData.last_name || ''}`
                        )
                      : item?.consent_template_content?.includes('{#name#}')
                      ? beneficiary.beneficiaryAuthType === 'Demographics'? item?.consent_template_content.replace(
                        '{#name#},',
                        `${''}`
                      ) : item?.consent_template_content.replace(
                          '{#name#}',
                          `${aadhaarName.trim() || ''}`
                        )
                      : item?.consent_template_content
                    }
                  />
                ))}
              </div>
              <div className="aadhar-submit">
                <Button
                  onClick={handletoAadhar}
                  disabled={isAllChecked ? false : true}
                  id="aadhar-beneficiary-submit"
                  buttonName={'Submit'}
                  colorType={'primary'}
                  icon={''}
                  iconPosition={''}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
 
export default AadharModal;
